let isFavicon = false; // Track current logo state

document.addEventListener('scroll', function() {
    const logo = document.querySelector('.header__heading-logo');
    const scrollPosition = window.scrollY;

    // Check if we need to swap logo
    if (scrollPosition > 100 && !isFavicon) {
        // Add fade class for animation
        logo.classList.add('fade');

        setTimeout(() => {
            logo.src = 'https://yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Submark-1.png?crop=center&height=50&v=1746685608&width=50';
            logo.srcset = '';
            logo.width = '50';
            logo.height = '50';
            logo.sizes = '50px';
            logo.classList.remove('fade');
            isFavicon = true; // Update state
        }, 300); // Match with CSS transition duration
    } else if (scrollPosition <= 100 && isFavicon) {
        // Add fade class for animation
        logo.classList.add('fade');

        setTimeout(() => {
            logo.src = '//yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=600';
            logo.srcset = '//yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=100 100w, //yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=150 150w, //yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=200 200w';
            logo.width = '100';
            logo.height = '44.61538461538462';
            logo.sizes = '(min-width: 750px) 100px, 50vw';
            logo.classList.remove('fade');
            isFavicon = false; // Update state
        }, 300); // Match with CSS transition duration
    }
});



// banner slider sections js 
document.addEventListener('DOMContentLoaded', function() {
    const mobileWidth = 768;
    const slides = [
      {
            // banner 1 mobile image
            id: 'Slide-template--27421824844055__slideshow_r397Hj-1',
            // mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Main_mobile_1.jpg?v=1783334723'
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/ChatGPT_Image_Sep_10_2026_08_42_35_PM.png?v=1789053167'
        },
        // {
        //     // banner 2 mobile image
        //     id: 'Slide-template--24335250194711__slideshow_r397Hj-2',
        //     mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen-_Banners_11.jpg?v=1773734738'
        // },
    ];


    function updateSlideImages() {
        const isMobile = window.innerWidth < mobileWidth;
        
        slides.forEach(slide => {
            const slideElement = document.getElementById(slide.id);
            if (slideElement) {
                
                // Apply the 390px height only to this specific slide ID when on mobile
                if (slide.id === 'Slide-template--27421824844055__slideshow_r397Hj-1') {
                    if (isMobile) {
                        slideElement.style.setProperty('height', '340px', 'important');
                    } else {
                        slideElement.style.removeProperty('height');
                    }
                }

                const imgElement = slideElement.querySelector('img');
                if (imgElement) {
                    if (isMobile) {
                        imgElement.src = slide.mobileImg;
                        imgElement.srcset = `${slide.mobileImg} 375w, ${slide.mobileImg} 550w, ${slide.mobileImg} 750w`;
                    } else {
                        const originalSrc = imgElement.getAttribute('data-original-src') || imgElement.src;
                        imgElement.src = originalSrc;
                        imgElement.srcset = imgElement.getAttribute('data-original-srcset') || imgElement.srcset;
                    }
                }
            }
        });
    }




    // Store original image sources
    slides.forEach(slide => {
        const slideElement = document.getElementById(slide.id);
        if (slideElement) {
            const imgElement = slideElement.querySelector('img');
            if (imgElement) {
                imgElement.setAttribute('data-original-src', imgElement.src);
                imgElement.setAttribute('data-original-srcset', imgElement.srcset);
            }
        }
    });

    // Initial check
    updateSlideImages();

    // Update on window resize
    window.addEventListener('resize', updateSlideImages);



    // Add link to the first banner {banner 1 link}
    const valentineBanner = document.getElementById('Slide-template--24335250194711__slideshow_r397Hj-1');
    if (valentineBanner) {
        valentineBanner.style.cursor = 'pointer';
        valentineBanner.addEventListener('click', function() {
            window.location.href = 'https://yarnen.in/collections/best-before-it-s-gone';
        });
    }


    // Add link to the second banner {banner 2 link}
    const secondBanner = document.getElementById('Slide-template--24335250194711__slideshow_r397Hj-2');
    if (secondBanner) {
        secondBanner.style.cursor = 'pointer';
        secondBanner.addEventListener('click', function() {
            // Replace the URL below with your desired link
            window.location.href = 'https://yarnen.in/collections/indivogue'; 
        });
    }


});

// Accordion
function toggleAccordion(header) {
    const content = header.nextElementSibling;
    header.classList.toggle('collapsed');
    content.classList.toggle('collapsed');
}